<script lang="ts">
  import { onMount } from 'svelte';
  import { tweened } from 'svelte/motion';
  import { cubicOut } from 'svelte/easing';

  let { score = 0, size = 120, strokeWidth = 10, label = 'Health' } = $props();

  const progress = tweened(0, {
    duration: 1500,
    easing: cubicOut
  });

  $effect(() => {
    progress.set(score);
  });

  let radius = $derived((size - strokeWidth) / 2);
  let circumference = $derived(2 * Math.PI * radius);
  let offset = $derived(circumference - ($progress / 100) * circumference);

  function getScoreColor(s: number) {
    if (s >= 90) return '#10b981'; // Success
    if (s >= 70) return '#f59e0b'; // Warning
    return '#ef4444'; // Error
  }
</script>

<div class="relative flex items-center justify-center" style="width: {size}px; height: {size}px;">
  <svg width={size} height={size} viewBox="0 0 100 100" class="transform -rotate-90 block">
    <!-- Background Circle -->
    <circle
      cx="50"
      cy="50"
      r="45"
      fill="transparent"
      stroke="currentColor"
      stroke-width="8"
      class="text-base-content/10"
    />
    <!-- Progress Circle -->
    <circle
      cx="50"
      cy="50"
      r="45"
      fill="transparent"
      stroke={getScoreColor($progress)}
      stroke-width="8"
      stroke-dasharray="282.7"
      stroke-dashoffset={282.7 - ($progress / 100) * 282.7}
      stroke-linecap="round"
      class="transition-all duration-300 ease-out"
      style="filter: drop-shadow(0 0 6px {getScoreColor($progress)}80)"
    />
  </svg>
  
  <div class="absolute inset-0 flex flex-col items-center justify-center text-center">
    <span class="text-2xl font-black tracking-tight" style="color: {getScoreColor($progress)}">
      {Math.round($progress)}%
    </span>
    <span class="text-[9px] uppercase font-bold tracking-widest text-base-content/40">{label}</span>
  </div>
</div>

<style>
  circle {
    transition: stroke-dashoffset 0.5s ease-out;
  }
</style>
